module.exports = __webpack_public_path__ + "img/futsal-dark.6243965e.svg";